import { render } from "./ProfitExpectancyIcon.vue?vue&type=template&id=0c600905"
import script from "./ProfitExpectancyIcon.vue?vue&type=script&lang=js"
export * from "./ProfitExpectancyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__